/**
 * Storefront route helpers for the cart → checkout journey.
 *
 * One source of truth for the paths the breadcrumb, the "continue to
 * checkout" button and the router all have to agree on. Until KAN-922
 * the breadcrumb carried a literal ``/<lang>/cart/checkout`` while the
 * router registered ``/:lang/checkout`` — the crumb 404'd for every
 * customer who clicked it.
 */

export function cartPath(lang: string): string {
  return `/${lang}/cart`;
}

export function checkoutPath(lang: string): string {
  return `/${lang}/checkout`;
}

/**
 * Route segment (relative to ``/:lang``) that older links — e-mails,
 * bookmarks, the pre-KAN-922 breadcrumb — still point at. The shell
 * mounts a redirect on it so those links land on :func:`checkoutPath`.
 */
export const LEGACY_CHECKOUT_SEGMENT = "cart/checkout";
